export const validateDimensionName = (name = '') => {
  // Dimension name need to less than 50
  if (name.length > 256) {
    return {
      failed: true,
      message: 'Exceeds the maximum character limit (256)',
    };
  }

  // Validate legality
  const regex = /^[\w\s]+$/;
  if (!regex.test(name) && name !== '') {
    return {
      failed: true,
      message: 'Must contain only letters, numbers, spaces and underscore',
    };
  }
  return {
    failed: false,
    message: '',
  };
};
